import { render } from "./SupplyDialog.vue?vue&type=template&id=3939fcfb&scoped=true&ts=true"
import script from "./SupplyDialog.vue?vue&type=script&lang=ts"
export * from "./SupplyDialog.vue?vue&type=script&lang=ts"

import "./SupplyDialog.vue?vue&type=style&index=0&id=3939fcfb&scoped=true&lang=scss"
import "./SupplyDialog.vue?vue&type=style&index=1&id=3939fcfb&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3939fcfb"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QSlider from 'quasar/src/components/slider/QSlider.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QSlider,QBtn,QField});
